app.apply(app.plugins, {
  /**
   * The initialisation of the shared view listener.
   * This view listener in initialised on every page.
   * @public
   * @param {string} container
  */

  init: function init(container) {
    var shared = new app.views.shared();
    shared.init(container);
  },
  /**
   * The initialisation of the payment adjustment plugin.
   * Note: Allows you to adjust your payments and instalments for a payment plan.
   * @public
   * @param {string} container
   */

  initPaymentAdjustment: function initPaymentAdjustment(container) {
    $(container).find('[data-payment-adjustment]').each(function () {
      $(this).app_paymentAdjustment();
    });
  },
  /**
   * The initialisation of the totals plugin.
   * @public
   * @param {string} container
   */

  initTotals: function initTotals(container) {
    $(container).find('[data-total]').each(function () {
      $(this).app_totals();
    });
  },
  /**
  * The initialisation of the debts plugin.
  * @public
  * @param {string} container
  */

  initDebts: function initDebts(container) {
    $(container).find('[data-debts]').each(function () {
      $(this).app_debts();
    });
  }
});